<template>
  <div>
    <!-- 实例 -->
    <div class="instances">
      <div>
        <Button
          type="primary"
          @click="modal = true"
          v-hasPermission="['aiMonitor:applicationConfiguration:add_instance']"
          >{{ $t("smartMonitor.applicationSystem.addInstance") }}</Button
        >
      </div>
    </div>
    <Modal
      v-model="modal"
      title="添加实例"
      width="900px;"
      :loading="modalLoading"
      ok-text="添加"
      :mask-closable="false"
    >
      <Form
        :model="resourceForm"
        :label-width="100"
        ref="resourceForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <Col span="8">
            <!-- 账户 -->
            <FormItem label="账户" prop="account" :label-width="50">
              <Select
                filterable
                v-model="resourceForm.account"
                @on-change="changeAccount(resourceForm.account)"
                :transfer="true"
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" style="z-index: 200">
            <!-- 存储区域 -->
            <FormItem label="存储区域" prop="region" :label-width="80">
              <Select
                filterable
                @on-change="changeRegion(resourceForm.region)"
                v-model="resourceForm.region"
                :transfer="true"
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- 标签 -->
            <FormItem label="标签" prop="tags" :label-width="40">
              <Input v-model="resourceForm.tags" placeholder="请输入值" />
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float:right;"
            v-show="isShowSearch"
            @click="searchInstancesInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancel('resourceForm')">取消</Button>
        <Button
          type="primary"
          @click="handleSubmit('resourceForm')"
          :loading="addloading"
          :disabled="isDisable"
          >添加</Button
        >
      </div>
      <Table
        :no-data-text="$t('common.noData')"
        ref="selection"
        :columns="columns4"
        :loading="loading"
        :data="queryAccountInstancesData"
        :height="400"
        @on-selection-change="getSelection"
      ></Table>
    </Modal>
    <table-instances></table-instances>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil.js";
import TableInstances from "../application_configuration/TableInstances";

var tableInstances = TableInstances;
export default {
  name: "AddInstances",
  components: {
    TableInstances
  },
  data() {
    return {
      selection: [],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      accountList: [],
      regionList: [],
      isShowSearch: false,
      resourceForm: {
        account: "",
        region: "",
        tags: ""
      },
      ruleValidate: {
        account: [
          {
            required: true,
            message: "请选择账户名称",
            trigger: "change",
            type: "number"
          }
        ],
        region: [
          { required: true, message: "请选择存储区域", trigger: "change" }
        ]
      },
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.name"),
          key: "name",
          width: "120px"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.instanceID"),
          key: "instanceId"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName"
        }
      ],
      queryAccountInstancesData: [],
      newQueryAccountInstancesDataList: []
    };
  },
  mounted: function() {
    this.selectAccount();
  },
  methods: {
    // 查询账户
    selectAccount: function() {
      this.$api.account
        .queryAccountsByCloudType("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
    },
    // 切换账户
    changeAccount: function() {
      if (
        this.resourceForm.account == "" ||
        this.resourceForm.account == null
      ) {
        return;
      }
      this.resourceForm.region = "";
      this.isShowSearch = true;
      this.$api.account
        .queryAccountRegions("accountId", this.resourceForm.account)
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 切换存储区域
    changeRegion: function() {
      this.instanceList = [];
      this.isShowSearch = true;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountInstancesDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableQueryAccountInstancesDataCopy = new Object();
        TableQueryAccountInstancesDataCopy.instanceId = this.selection[
          i
        ].instanceId;
        TableQueryAccountInstancesDataCopy.name = this.selection[i].name;
        TableQueryAccountInstancesDataCopy.privateIp = this.selection[
          i
        ].privateIp;
        TableQueryAccountInstancesDataCopy.state = this.selection[i].state;
        TableQueryAccountInstancesDataCopy.region = this.selection[i].region;
        TableQueryAccountInstancesDataCopy.accountId = this.selection[
          i
        ].accountId;
        this.newQueryAccountInstancesDataList.push(
          TableQueryAccountInstancesDataCopy
        );
      }

      // 选了数据 可以点击下一步
      if (this.newQueryAccountInstancesDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchInstancesInput: function() {
      if (
        this.resourceForm.account == "" ||
        this.resourceForm.account == null ||
        this.resourceForm.region == "" ||
        this.resourceForm.region == null
      ) {
        return;
      }
      // 根据AccountId查询Instance列表
      this.$api.instance
        .queryInstanceByGroupMSP({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          region: this.resourceForm.region,
          accountId: this.resourceForm.account,
          tags: this.resourceForm.tags
        })
        .then(res => {
          this.queryAccountInstancesData = res.data.instanceDTOS;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加instance
          this.addloading = true;
          this.$api.applicationInstanceRelation
            .createApplicationInstanceRelation({
              applicationId: this.$route.query.id,
              alertRuleName: this.$route.query.alertRuleName,
              instanceDTOS: this.newQueryAccountInstancesDataList
            })
            .then(res => {
              setTimeout(() => {
                tableInstances.methods.showAllInstance();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success("添加成功");
                this.queryAccountInstancesData = [];
                this.newQueryAccountInstancesDataList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    // 取消
    cancel: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.queryAccountInstancesData = [];
      this.newQueryAccountInstancesDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style scoped>
.instances {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  overflow: hidden;
}
.instances > div:nth-child(1) {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/AddInstances.vue